<dynamic-form
  *ngIf="isOk4Loading"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [areaName]="areaName"
  [noSubmit]="true"
  [columns]="columns"
  [isShowModal]="false"
  (cancelChange)="cancel()"
  (valueChange)="onChanged($event)"
  (submitChange)="save()">
  <ng-container class="content">
    <kgrid
      #Grid
      *ngIf="headerColumns && headerColumns.length"
      [apiName]="apiName"
      [areaName]="areaName"
      [label]="label"
      [name]="apiName"
      [noToolBar]="true"
      [filtering]="false"
      [groupable]="false"
      [isAdd]="false"
      [isDelete]="false"
      [isEdit]="false"
      [columns]="headerColumns"
      [(dataList)]="datalist"
      (onRowSelected)="onRowSelected($event)"
      [isMulti]="false"
      [isModal]="false">
    </kgrid>
  </ng-container>
  <ng-container class="footer">
    <ssg-button buttontype="button" class="action-btn" (click)="moveUp()" label="حرکت به بالا" icon="icon-expand_less-o"></ssg-button>
    <ssg-button buttontype="button" class="action-btn" (click)="moveDown()" label="حرکت به پایین" icon="icon-expand_more-o"></ssg-button>
    <ssg-button
      buttontype="button"
      class="action-btn"
      (click)="voucherRenumber()"
      label="شماره گذاری اسناد"
      icon="icon-text-box-check-outline"></ssg-button>
  </ng-container>
</dynamic-form>
